import React from "react";
import { Button } from "antd";

//import multilanguage library
import { useTranslation } from "react-i18next";

// Styles
import { Img } from "./styles";

const SelectLanguageComponent = () => {
  //To translate text
  const { i18n } = useTranslation();

  const handleClick = (leng) => i18n.changeLanguage(leng);

  return (
    <span>
      <Button
        size="small"
        ghost
        shape="circle"
        onClick={() => handleClick("es-ES")}
        type={i18n.language === "es-ES" ? "primary" : "default"}
      >
        <Img alt="es-ES" src="/bikitt/flags/es-ES.png" />
      </Button>
      <Button size="small" ghost shape="circle" onClick={() => handleClick("eus")} type={i18n.language === "eus" ? "primary" : "default"}>
        <Img alt="eus" src="/bikitt/flags/eus.png" />
      </Button>
      <Button
        size="small"
        ghost
        shape="circle"
        onClick={() => handleClick("en-US")}
        type={i18n.language === "en-US" ? "primary" : "default"}
      >
        <Img alt="en-UK" src="/bikitt/flags/en-UK.png" />
      </Button>
    </span>
  );
};
export default SelectLanguageComponent;
